<template>
    <el-form :model="loginForm" :rules="loginRule" ref="loginForm" label-position="left" label-width="0px"
             class="demo-ruleForm login-container">
        <h3 class="title">荣康万家管理平台</h3>
        <el-form-item prop="name">
            <el-input type="text" v-model="loginForm.name" auto-complete="off" placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
        <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click.native.prevent="login" :loading="logining">登录
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import {requestPost} from '../api/api';
    import NProgress from 'nprogress'

    export default {
        data() {
            return {
                logining: false,
                checked: true,
                loginForm: {
                    name: localStorage.getItem('name') ? localStorage.getItem('name') : '',
                    password: localStorage.getItem('password') ? localStorage.getItem('password') : ''
                    //name:'test',
                    //password:'123456'
                },
                loginRule: {
                    name: [
                        {required: true, message: '请输入账号', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ]
                },
                checked: true
            };
        },
        methods: {
            login(e) {
                var _this = this;
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.logining = true;
                        NProgress.start();
                        var params = Object.assign({}, this.loginForm);
                        let url = 'user/login.do';
                        requestPost(_this, url, params).then(res => {
                            this.logining = false;
                            NProgress.done();
                            if (res !== '') {
                                //this.$store.state.type=res.data.type; 存在store数据会丢失
                                sessionStorage.setItem('type', res.data.type);
                                sessionStorage.setItem('token', res.data.token);
                                if (this.checked) {
                                    localStorage.setItem('name', params.name);
                                    localStorage.setItem('password', params.password);
                                } else {
                                    localStorage.removeItem('name');
                                    localStorage.removeItem('password');
                                }

                                    this.$router.push({path: '/echarts'});


                            }
                        });
                    } else {
                        return false;
                    }
                });
            }
        }
    }

</script>

<style lang="scss" scoped type="text/scss">
    .login-container {
        /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        margin: 180px auto;
        width: 350px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }
        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// Login.vue?2b3e6b9e